import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { uploadObject } from '../../rest/data';
import { copyRestObject, DictionaryLink, Language } from '../../rest/models';
import { Valid, RequestStatusDisplay } from '../CommonComponents';
import { Button, Input } from "../RequestRespectingInputs";
import { InfoTrigger } from '../info_popup/InfoTrigger';
import { DictionaryExplanations } from './explanation';
import { useState } from 'react';
import { RequestStatus } from '../../api_request/api_request';
import { getModelArr } from '../../rest/slice';

export function DictLinkEditForm(props: Props)
{
    const appDispatch = useAppDispatch();
    const l = props.lang;

    function copyDict(d?: DictionaryLink)
    {
        const ret = copyRestObject(d ?? new DictionaryLink(), DictionaryLink);
        ret.language = l?.key ?? null;

        return ret;
    }

    //The dictionary as it is in the editor form.
    const [d, setD] = useState(copyDict(props.dict));

    //Keeps track of what's happening with the request.
    const [request, setRequest] = useState<RequestStatus|undefined>(undefined);

    const isDuplicate = (getModelArr(useAppSelector, DictionaryLink) ?? [])
        .filter(d2 => d.text === d2.text) //Objects with the same properties as the current form.
        .some(d2 => d.key !== d2.key); //Unless it's the same object that we're editing. It can equal itself.

    const textInput = 
        <Input
            type='text'
            value={d.text}
            maxLength={100}
            onChange={(e) => {d.text = e.currentTarget.value; setD({...d});}} />

    const urlInput = 
        <Input
            type='text'
            value={d.urlpattern}
            maxLength={100}
            onChange={(e) => {d.urlpattern = e.currentTarget.value; setD({...d});}} />
    
    const submitButton = 
        <Button
            onClick={async function()
            {
                if (isDuplicate)
                {
                    window.alert('This dictionary has the same text and language as another one.');
                    return;
                }

                const status = await uploadObject(d, DictionaryLink, appDispatch, setRequest);
                if (status.success)
                {
                    setD(copyDict());
                    props.onDone();
                }
            }}>Submit</Button>;
    
    const form = 
        <div>
            <table border={1}>
                <tbody>
                    <tr>
                        <td>
                            <b>Button text</b>
                        </td>
                        <td>
                            {textInput}
                            <Valid bValid={d.text.trim() || !d.id} children='Dictionaries must have text.'/>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <b>URL pattern</b>
                            <InfoTrigger children={DictionaryExplanations.url_pattern}/>
                        </td>
                        <td>
                            {urlInput}
                            <Valid bValid={d.urlpattern.trim() || !d.id} children='Dictionaries must have a URL pattern.'/>
                        </td>
                    </tr>
                </tbody>
            </table>
            
            {submitButton}
            {d.id ? <Button onClick={(e) => props.onDone()}>Hide</Button> : <></>}
        </div>;

    const createOrEdit = d.id ? 'Edit' : 'Create';
    return (
        <div className={`ernots_${createOrEdit}ModelForm`}>
            {form}
            <RequestStatusDisplay request={request}/>
        </div>);
}

interface Props
{
    dict?: DictionaryLink;
    lang?: Language;
    onDone: () => void;
}